<template>
  <Multiselect
    :class="{
      'border !border-red': errors,
      'isInTabsComponent:!bg-lightPrimaryColor dark:isInTabsComponent:!bg-neutral-900': true,
    }"
    :classes="{
      container:
        'min-h-[1.75rem] min-w-0 text-lightSecondaryTextColor dark:text-darkSecondaryTextColor relative w-full max-w-[min(100%,35rem)] flex items-center justify-end box-border cursor-pointer border border-transparent dark:border-darkSecondaryColor rounded-md bg-lightSecondaryColor dark:bg-neutral-900 text-base leading-snug outline-none shadow-inner',
      containerDisabled:
        'text-lightTertiaryColor dark:text-darkTertiaryColor dark:!bg-darkPrimaryColor shadow-none pointer-events-none',
      containerOpen: 'rounded-b-none',
      containerOpenTop: 'rounded-t-none',
      containerActive: '!border-primary',
      wrapper: 'relative mx-auto w-full flex items-center justify-end box-border cursor-pointer outline-none min-h-[1.75rem]',
      singleLabel:
        'flex items-center h-full max-w-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 md:pr-16 pr-4 box-border rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5',
      singleLabelText: 'overflow-ellipsis overflow-hidden block whitespace-nowrap max-w-full min-w-[1rem]',
      multipleLabel:
        'flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5',
      search:
        'w-full absolute inset-0 outline-none focus:ring-0 appearance-none box-border border-0 text-base font-sans bg-inherit rounded pl-3.5 rtl:pl-0 rtl:pr-3.5',
      tags: 'flex-grow flex-shrink flex flex-wrap items-center mt-1 pl-2 rtl:pl-0 rtl:pr-2',
      tag: 'bg-black/60 dark:bg-white/20 text-white text-sm font-semibold py-0.3 pl-2 rounded mr-1 mb-1 flex items-center whitespace-nowrap rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1',
      tagDisabled: '!cursor-not-allowed pr-2 opacity-50 rtl:pl-2',
      tagWrapper: 'whitespace-nowrap overflow-hidden overflow-ellipsis',
      tagWrapperBreak: 'whitespace-normal break-all',
      tagRemove: 'flex items-center justify-center p-1 mx-0.5 rounded-sm hover:bg-black hover:bg-opacity-10 group',
      tagRemoveIcon: 'bg-multiselect-remove bg-center bg-no-repeat inline-block w-3 h-3 group-hover:opacity-60',
      tagsSearchWrapper: 'inline-block relative mx-1 mb-1 flex-grow flex-shrink h-full',
      tagsSearch:
        'absolute inset-0 border-0 bg-inherit outline-none focus:ring-0 appearance-none p-0 text-base font-sans box-border w-full',
      tagsSearchCopy: 'invisible whitespace-pre-wrap inline-block h-px',
      placeholder:
        'flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 text-lightTertiaryColor dark:text-darkTertiaryColor rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5',
      caret:
        'bg-multiselect-caret dark:invert bg-center bg-no-repeat w-2.5 h-4 py-px box-content mr-3.5 relative z-10 opacity-40 flex-shrink-0 flex-grow-0 transition-transform transform pointer-events-none rtl:mr-0 rtl:ml-3.5',
      caretOpen: 'rotate-180 pointer-events-auto',
      clear:
        'pr-3.5 relative z-10 invert dark:invert-0 opacity-40 transition duration-300 flex-shrink-0 flex-grow-0 flex hover:opacity-80 rtl:pr-0 rtl:pl-3.5',
      clearIcon: 'bg-multiselect-remove bg-center bg-no-repeat w-2.5 h-4 py-px box-content inline-block',
      spinner:
        'bg-multiselect-spinner bg-center bg-no-repeat w-4 h-4 z-10 mr-3.5 animate-spin flex-shrink-0 flex-grow-0 rtl:mr-0 rtl:ml-3.5',
      inifite: 'flex items-center justify-center w-full',
      inifiteSpinner: 'bg-multiselect-spinner bg-center bg-no-repeat w-4 h-4 z-10 animate-spin flex-shrink-0 flex-grow-0 m-3.5',
      dropdown:
        '!overflow-auto max-h-60 absolute -left-px -right-px bottom-0 transform translate-y-full border border-lightSecondaryColor dark:border-darkSecondaryColor -mt-px overflow-y-scroll z-50 bg-lightSecondaryColor dark:bg-neutral-900 flex flex-col rounded-b ',
      dropdownTop: '-translate-y-full top-px bottom-auto rounded-b-none rounded-t',
      dropdownHidden: 'hidden',
      options: 'flex flex-col p-0 m-0 list-none',
      optionsTop: '',
      group: 'p-0 m-0',
      groupLabel:
        'flex text-sm box-border items-center justify-start text-left py-1 px-3 font-semibold bg-lightSecondaryColor dark:bg-neutral-900 dark:border dark:border-darkPrimaryColor cursor-default leading-normal',
      groupLabelPointable: 'cursor-pointer',
      groupLabelPointed: '!bg-primary/20 text-lightPrimaryTextColor dark:text-darkPrimaryTextColor',
      groupLabelSelected: '!bg-primary text-white',
      groupLabelDisabled: '',
      groupLabelSelectedPointed: '!bg-primary text-white opacity-90',
      groupLabelSelectedDisabled: 'text-green bg-green-600 bg-opacity-50',
      groupOptions: 'p-0 m-0 pl-3',
      option:
        'flex items-center justify-start box-border text-left cursor-pointer text-base text-lightSecondaryTextColor dark:text-darkSecondaryTextColor leading-snug py-2 px-3',
      optionPointed: 'text-lightPrimaryTextColor dark:text-darkPrimaryTextColor bg-primary/20',
      optionSelected: 'text-white bg-primary',
      optionDisabled: 'text-lightTertiaryColor dark:text-darkTertiaryColor dark:bg-darkPrimaryColor !cursor-not-allowed',
      optionSelectedPointed: 'text-white !bg-primary opacity-90',
      optionSelectedDisabled: '!cursor-not-allowed text-green !bg-primary bg-opacity-50',
      noOptions:
        'py-2 px-3 text-base text-lightPrimaryTextColor dark:text-darkPrimaryTextColor bg-lightSecondaryColor dark:bg-neutral-900 text-left',
      noResults:
        'py-2 px-3 text-base text-lightPrimaryTextColor dark:text-darkPrimaryTextColor bg-lightSecondaryColor dark:bg-neutral-900 text-left',
      fakeInput:
        'bg-transparent absolute left-0 right-0 -bottom-px w-full h-px border-0 p-0 appearance-none outline-none text-transparent',
      assist: 'absolute -m-px w-px h-px overflow-hidden',
      spacer: 'h-[1.7rem] py-px box-content',
    }"
    :can-clear="isClearable ? true : false"
    :can-deselect="isClearable ? true : false"
    :close-on-deselect="isClearable ? true : false"
    :no-options-text="$t('message.listIsEmpty')"
    v-bind="$attrs"
    @input="clearErrors"
  >
    <template v-for="(_, field) in $slots" #[field]="data">
      <slot :name="field" v-bind="data" />
    </template>
  </Multiselect>
</template>

<script setup lang="ts">
import Multiselect from "@vueform/multiselect";
import { useErrors } from "../errors/useErrors";

defineSlots<{
  [key: string]: unknown;
}>();

withDefaults(
  defineProps<{
    isClearable?: boolean;
  }>(),
  {
    isClearable: false,
  },
);

const { errors, clearErrors } = useErrors();
</script>
